<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content>
  <form [formGroup]="addressForm">
    <!-- Input fields -->
    <ion-label class="title">{{ 'profile.personaldetails.editaddress:title' | translate }}</ion-label>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'profile.personaldetails.editaddress.street' | translate }}"
        labelPlacement="stacked"
        autocomplete="off"
        [type]="'text'"
        formControlName="street"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('street', 'required')">{{ 'profile.personaldetails.editaddress.errormessage.street' | translate }}</span>
    </div>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'profile.personaldetails.editaddress.number' | translate }}"
        labelPlacement="stacked"
        autocomplete="off"
        [type]="'text'"
        formControlName="number"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('number', 'required')">{{ 'profile.personaldetails.editaddress.errormessage.number' | translate }}</span>
    </div>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'profile.personaldetails.editaddress.postalcode' | translate }}"
        labelPlacement="stacked"
        autocomplete="off"
        [type]="'tel'"
        formControlName="zip"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('zip', 'required')">{{ 'profile.personaldetails.editaddress.errormessage.postalcode' | translate }}</span>
      <span *ngIf="hasError('zip', 'invalidZip')">{{ 'profile.personaldetails.editaddress.errormessage.invalidZip' | translate }}</span>
    </div>
    <ion-item class="item-input" mode="md">
      <ion-input
        label="{{ 'profile.personaldetails.editaddress.city' | translate }}"
        labelPlacement="stacked"
        autocomplete="off"
        [type]="'text'"
        formControlName="city"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="hasError('city', 'required')">{{ 'profile.personaldetails.editaddress.errormessage.city' | translate }}</span>
    </div>
    <p>
      {{ 'profile.personaldetails.editaddress.note' | translate }}
      <a (click)="dismiss()" [routerLink]="['tabs', 'account', 'support']" [queryParams]="{ addressChange: 'true' }">
        {{ 'profile.personaldetails.editaddress.link' | translate }}
      </a>
      .
    </p>
    <!-- Save changes -->
    <ion-button class="action-btn" (click)="save()" mode="ios" expand="block">{{ 'SHARED.actions.saveChanges' | translate }}</ion-button>
  </form>
</ion-content>
